import React from 'react';
import { AppRouter } from './router';
import { BreakpointsContextProvider } from './services/breakpoints';
import { Notifications } from './components/common/Notifications';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { AppErrorBoundary } from './components/common/ErrorBoundary';

export const App = () => {

    return (
        <SentryErrorBoundary fallback={AppErrorBoundary}>
            <BreakpointsContextProvider>
                <AppRouter />

                <Notifications />
            </BreakpointsContextProvider>
        </SentryErrorBoundary>
    );
};

export default App;
